import {ITokenStatus} from '../../models/Token';

export const FETCH_TOKEN_STATUS = 'FETCH_TOKEN_STATUS';
export const FETCH_TOKEN_STATUS_SUCCESS = 'FETCH_TOKEN_STATUS_SUCCESS';
export const FETCH_TOKEN_STATUS_ERROR = 'FETCH_TOKEN_STATUS_ERROR';

export const ADD_WHITELISTED_ADDRESS = 'ADD_WHITELISTED_ADDRESS';
export const ADD_WHITELISTED_ADDRESS_SUCCESS =
  'ADD_WHITELISTED_ADDRESS_SUCCESS';
export const ADD_WHITELISTED_ADDRESS_ERROR = 'ADD_WHITELISTED_ADDRESS_ERROR ';

export const REMOVE_WHITELISTED_ADDRESS = 'REMOVE_WHITELISTED_ADDRESS';
export const REMOVE_WHITELISTED_ADDRESS_SUCCESS =
  'REMOVE_WHITELISTED_ADDRESS_SUCCESS';
export const REMOVE_WHITELISTED_ADDRESS_ERROR =
  'REMOVE_WHITELISTED_ADDRESS_ERROR ';

export const UPDATING_TOKEN_STATUS = 'UPDATING_TOKEN_STATUS';
export const UPDATING_TOKEN_STATUS_SUCCESS = 'UPDATING_TOKEN_STATUS_SUCCESS';
export const UPDATING_TOKEN_STATUS_ERROR = 'UPDATING_TOKEN_STATUS_ERROR';

export interface FetchTokenStatus {
  type: typeof FETCH_TOKEN_STATUS;
}

export interface FetchTokenStatusSuccess {
  type: typeof FETCH_TOKEN_STATUS_SUCCESS;
  payload: ITokenStatus;
}

export interface FetchTokenStatusError {
  type: typeof FETCH_TOKEN_STATUS_ERROR;
}

export interface AddWhitelistedAddress {
  type: typeof ADD_WHITELISTED_ADDRESS;
}

export interface AddWhitelistedAddressSuccess {
  type: typeof ADD_WHITELISTED_ADDRESS_SUCCESS;
  payload: string;
}

export interface AddWhitelistedAddressError {
  type: typeof ADD_WHITELISTED_ADDRESS_ERROR;
  payload: string;
}

export interface RemoveWhitelistedAddress {
  type: typeof REMOVE_WHITELISTED_ADDRESS;
}

export interface RemoveWhitelistedAddressSuccess {
  type: typeof REMOVE_WHITELISTED_ADDRESS_SUCCESS;
  payload: string;
}

export interface RemoveWhitelistedAddressError {
  type: typeof REMOVE_WHITELISTED_ADDRESS_ERROR;
}

export interface UpdatingTokenStatus {
  type: typeof UPDATING_TOKEN_STATUS;
}

export interface UpdatingTokenStatusSuccess {
  type: typeof UPDATING_TOKEN_STATUS_SUCCESS;
}

export interface UpdatingTokenStatusError {
  type: typeof UPDATING_TOKEN_STATUS_ERROR;
}

export type TokenStatusActionTypes =
  | FetchTokenStatus
  | FetchTokenStatusSuccess
  | FetchTokenStatusError
  | AddWhitelistedAddress
  | AddWhitelistedAddressSuccess
  | AddWhitelistedAddressError
  | RemoveWhitelistedAddress
  | RemoveWhitelistedAddressSuccess
  | RemoveWhitelistedAddressError
  | UpdatingTokenStatus
  | UpdatingTokenStatusSuccess
  | UpdatingTokenStatusError;
